import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { DocumentService } from './document.service';
import * as Parse from 'parse';
import { OrganizationService } from './organization.service';

export type FileCategory = 'general-agreement' |
                           'agent-agreement' |
                           'training-material' |
                           'corporate-document' |
                           'other' |
                           'shared';

@Injectable()
export class FileService {
    constructor(
        private auth: AuthService,
        private documentService: DocumentService,
        private orgService: OrganizationService
    ) {}

    loadDocumentsByCategory(category: FileCategory) {
        const query: Parse.Query = new Parse.Query('AdminFile');

        query.equalTo('category', category);
        query.equalTo('organization', this.orgService.organization);
        query.descending('createdAt');

        return query.find();
    }

    async uploadDocument(file: File, category: FileCategory) {
        const fileName: string = file.name.replace(/.*\./gi, category + '_' + Math.random().toString(16).replace('.', '_') + '.');
        const parseFile: Parse.File = new Parse.File(fileName, file);

        const document: Parse.Object = new Parse.Object('AdminFile');
        document.set('file', parseFile);
        document.set('name', file.name);
        document.set('category', category);
        document.set('uploadedBy', this.auth.currentUser);
        document.set('organization', this.orgService.organization);

        try {
            // Generate thumbnail
            if (file.type === 'application/pdf') {
                const thubmnailBase64 = await this.documentService.generatePDFThumbnail(file);

                if (thubmnailBase64) {
                    const thumbnail: Parse.File = new Parse.File('thumb.png', { base64: thubmnailBase64 });
                    document.set('thumbnail', thumbnail);
                }
            } else {
                document.set('thumbnail', null);
            }
        } catch (error) {
            console.error(error);
            // Thumbnail creation can fail silently
        }

        return document.save();
    }
}
